import { InjectionToken } from '@angular/core';

export const HTTP_NOAUTH = new InjectionToken("http_noauth");